import React, { FunctionComponent } from 'react'
import Grid from '@sport1/react-elements/Grid'
import { BackgroundColorTypes } from '../../../../Theme/Fonts/FontTypes'
import BasicText from '../../../../Theme/Fonts/BasicText'
import { TestID } from '../../../../utils/PropTypesDefinitions'

export type FormItemType = 'WIN' | 'DRAW' | 'LOST'

export type FormItemProps = {
    type: FormItemType
} & TestID

type TypeData = {
    backgroundColor: BackgroundColorTypes
    text: string
}

const getTypeData = (type: FormItemType): TypeData => {
    switch (type) {
        case 'WIN':
            return {
                backgroundColor: 'GREEN',
                text: 'S',
            }
        case 'DRAW':
            return {
                backgroundColor: 'keshi-3',
                text: 'U',
            }
        case 'LOST':
            return {
                backgroundColor: 'RED',
                text: 'N',
            }
    }
}

const FormItem: FunctionComponent<FormItemProps> = ({ type, testID }) => {
    const { backgroundColor, text } = getTypeData(type)
    return (
        <Grid
            minHeight={16}
            maxHeight={16}
            maxWidth={16}
            minWidth={16}
            backgroundColor={backgroundColor}
            borderRadius={1}
            testID={testID}
            noExpand
        >
            <BasicText fontSize="FS14" lineHeight="LH16" color="WHITE" bold textAlign="center">
                {text}
            </BasicText>
        </Grid>
    )
}

export default FormItem
